/* eslint-disable no-undef */
class ExternalScripts {
    init () {
        this.liveChatConfig = {};
        try {
            // .dataset automatically converts data to CamelCase
            var config = document.getElementById('livechat-config').dataset;
            this.liveChatConfig = config;

            if (config.legacyScript === true || config.legacyScript === 'true') {
                this.liveagentInitLegacy();
                setTimeout(function () {
                    var chatId = $('#scriptId').attr('scriptId');
                    var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

                    if (onlineBtn && onlineBtn.style.display !== 'none') {
                        $('.not-available-chat').addClass('hidden');
                        $('.available-chat').removeClass('hidden');
                    } else {
                        $('.not-available-chat').removeClass('hidden');
                        $('.available-chat').addClass('hidden');
                    }
                    $('.availabilityContainer').css('display', 'none');
                }, 5000);
            } else {
                this.liveagentInit();
            }
            this.proactiveChatInit();
        } catch (e) {
            // Livechat might not be included in the page
        }
    }

    setAvailability () {
        var chatId = $('#scriptId').attr('scriptId');
        var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

        if (onlineBtn && onlineBtn.style.display !== 'none') {
            $('.not-available-chat').addClass('hidden');
            $('.available-chat').removeClass('hidden');
        } else {
            $('.not-available-chat').removeClass('hidden');
            $('.available-chat').addClass('hidden');
        }
        $('.availabilityContainer').css('display', 'none');
    }

    getChatId () {
        return this.liveChatConfig['staticChatId'];
    }

    openLiveChat () {
        var chatId = this.getChatId();
        var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);
        if (onlineBtn && onlineBtn.style.display !== 'none') {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
            onlineBtn.click();
        }
    }

    proactiveChatInit () {
        let liveChatContainer = 'livechat-desktop';
        if (!Foundation.MediaQuery.is('medium')) {
            liveChatContainer = 'livechat-mobile';
        }

        var scriptContainer = document.getElementById(liveChatContainer);
        if (scriptContainer) {
            $('body').append(scriptContainer.innerHTML);
        }
    }

    liveagentInitLegacy () {
        const livechatConfigElement = document.getElementById('livechat-config');

        if (!livechatConfigElement) {
            return false;
        }

        this.liveChatConfig = livechatConfigElement.dataset;

        /* global liveagent */
        liveagent.addCustomDetail('siteLanguage', this.liveChatConfig.language);
        if (this.liveChatConfig.customerName && this.liveChatConfig.customerEmail) {
            liveagent.addCustomDetail('customerName', this.liveChatConfig.customerName);
            liveagent.addCustomDetail('customerEmail', this.liveChatConfig.customerEmail);
        }

        if (document.getElementById('liveChatCurrentCountry')) {
            const liveChatCurrentCountry = document.getElementById('liveChatCurrentCountry').getAttribute('currentCountry');
            liveagent.addCustomDetail('siteCountry', liveChatCurrentCountry);
        }

        liveagent.init(this.liveChatConfig.initParam1, this.liveChatConfig.initParam2, this.liveChatConfig.initParam3);
        if (!window._laq) { window._laq = []; }
        window._laq.push(() => {
            if ($('#checkout-main').length === 0) {
                liveagent.showWhenOnline(this.liveChatConfig.staticChatId,
                    document.getElementById('liveagent_button_online_' + this.liveChatConfig.staticChatId));
                liveagent.showWhenOffline(this.liveChatConfig.staticChatId,
                    document.getElementById('liveagent_button_offline_' + this.liveChatConfig.staticChatId));
            }
        });

        $(document).on('click', '.js-live-chat', (e) =>
            this.openLiveChat()
        );

        var chatId = $('#scriptId').attr('scriptId');

        var observer = new MutationObserver(function (mutations) {
            var chatId = $('#scriptId').attr('scriptId');
            var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

            if (onlineBtn && onlineBtn.style.display !== 'none') {
                $('.not-available-chat').addClass('hidden');
                $('.available-chat').removeClass('hidden');
            } else {
                $('.not-available-chat').removeClass('hidden');
                $('.available-chat').addClass('hidden');
            }
            $('.availabilityContainer').css('display', 'none');
        });
        var target = document.querySelector('#liveagent_button_online_' + chatId);
        observer.observe(target, {
            attributes: true
        });
    }

    liveagentInit () {
        var _self = this;

        if (!window.embedded_svc || !window.embedded_svc.menu) {
            var s = document.createElement('script');
            s.setAttribute('src', this.liveChatConfig.script);
            s.onload = function () {
                _self.initESW(null);
            };
            document.body.appendChild(s);
        } else {
            this.initESW(this.liveChatConfig.initUrl);
        }
    }

    initESW (url) {
        embedded_svc.menu.settings.language = `${this.liveChatConfig.language}`;
        embedded_svc.menu.chat.settings.paramName = `${this.liveChatConfig.customerName}`;
        embedded_svc.menu.chat.settings.paramMail = `${this.liveChatConfig.customerEmail}`;
        embedded_svc.menu.chat.settings.paramBrand = `${this.liveChatConfig.brand}`;
        embedded_svc.menu.chat.settings.paramCountry = `${this.liveChatConfig.country}`;

        embedded_svc.menu.init(
            `${this.liveChatConfig.initParam1}`,
            `${this.liveChatConfig.initParam2}`,
            url,
            `${this.liveChatConfig.initParam3}`,
            `${this.liveChatConfig.initParam4}`,
            {
                pageName: `${this.liveChatConfig.pageName}`
            }
        );

        var styleEmb = document.createElement('style');
        styleEmb.type = 'text/css';
        styleEmb.id = 'embedded-styling';
        styleEmb.innerHTML = '.embedded-service .channelmenu_ctas li a { font-size: small;font-weight: normal;}';
        if (this.liveChatConfig.position === '1') {
            styleEmb.innerHTML += this.getTopPositionStyling();
        } else if (this.liveChatConfig.position === '3') {
            styleEmb.innerHTML += this.getCartPositionStyling();
        } else {
            styleEmb.innerHTML += this.getDefaultPositionStyling();
        }
        document.getElementsByTagName('head')[0].appendChild(styleEmb);
    }

    getCartPositionStyling () {
        var str = '';

        if (Foundation.MediaQuery.atLeast('large')) {
            // Style innerHTML button menu
            // Style innerHTML button menu
            str += ' .embedded-service .fab {bottom: 62px !important;right: 12px !important;}';
            // menu items
            str += ' .embedded-service .channelmenu {bottom: 137px !important;}';
            // menu minimize button
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 12px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 62px !important;right:12px !important;}';
            // chat container
            str += ' .embeddedServiceSidebar.layout-float .dockableContainer {bottom: 137px !important;}';
        } else {
            // Style innerHTML button menu Middle (only for Cart page)
            str += ' .embedded-service .fab {bottom: 126px !important;right: 5px !important;z-index:999 !important;}';
            // menu items
            str += ' .embedded-service .channelmenu {bottom: 50px !important;z-index:900 !important;display: initial !important;}';
            // menu minimize button
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 5px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 126px !important;right:5px !important;}';
        }

        return str;
    }

    getTopPositionStyling () {
        var str = '';

        if (Foundation.MediaQuery.atLeast('large')) {
            // Style innerHTML button menu
            str += ' .embedded-service .fab {bottom: 62px !important;right: 12px !important;}';
            // menu items
            str += ' .embedded-service .channelmenu {bottom: 137px !important;}';
            // menu minimize button
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 12px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 62px !important;right:12px !important;}';
            // chat container
            str += ' .embeddedServiceSidebar.layout-float .dockableContainer {bottom: 137px !important;}';
        } else {
            // Style innerHTML button menu
            str += ' .embedded-service .fab {bottom:unset !important;top:1px !important;right: 15px !important;z-index:1000 !important;}';
            str += ' .embedded-service .channelmenu {bottom:unset !important;top:76px;z-index:1000 !important;display: initial !important;}';
            // menu minimized
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {bottom:unset !important;top:76px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom:unset !important;top:1px !important;right: 15px !important;}';
        }

        return str;
    }

    getDefaultPositionStyling () {
        var str = '';

        if (Foundation.MediaQuery.atLeast('large')) {
            // Style innerHTML button menu
            str += ' .embedded-service .fab {bottom: 62px !important;right: 12px !important;}';
            // menu items
            str += ' .embedded-service .channelmenu {bottom: 137px !important;}';
            // menu minimize button
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 12px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 62px !important;right:12px !important;}';
            // chat container
            str += ' .embeddedServiceSidebar.layout-float .dockableContainer {bottom: 137px !important;}';
        } else {
            // Style innerHTML button menu
            str += ' .embedded-service .fab {bottom: 170px !important;right: 5px !important;z-index:900 !important;}';
            // menu items
            str += ' .embedded-service .channelmenu {bottom: 50px !important;z-index:900 !important;display: initial !important;}';
            // menu minimize button
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 5px !important;}';
            str += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 170px !important;right:5px !important;}';
        }

        return str;
    }
}

const external = new ExternalScripts();
window.openLiveChat = external.openLiveChat;
export default external;
